(function () {

	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	const initializeBlock = function ($block) {

		setupAccordion();

	};


  /**
   * Basec on the work of Heydon Pickering
   *
   * @see https://inclusive-components.design/collapsible-sections/
   */
	const setupAccordion = function () {

		const headings = document.querySelectorAll('.js-acf-accordion-subhead');

		if ( headings ) {

			Array.prototype.forEach.call(headings, heading => {

				heading.innerHTML = `
				<button aria-expanded="false">
					${heading.textContent}
					<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" aria-hidden="true">
  					<path fill="#FFF" d="M7.53379638,2.3526332 C8.12786499,1.8523649 8.99668367,1.89238579 9.54265436,2.42147319 L9.6473668,2.53379638 L17.6473668,12.0337964 C18.0861992,12.5549099 18.1154547,13.300247 17.7351333,13.851257 L17.6473668,13.9662036 L9.6473668,23.4662036 C9.11374727,24.0998768 8.16746957,24.1809863 7.53379638,23.6473668 C6.93972777,23.1470985 6.83131082,22.2841423 7.25976822,21.6560964 L7.3526332,21.5337964 L14.538,13 L7.3526332,4.46620362 C6.8523649,3.87213501 6.89238579,3.00331633 7.42147319,2.45734564 L7.53379638,2.3526332 Z" transform="rotate(90 12.5 13)"/>
					</svg>
				</button>
				`;

				const getContent = (elem) => {
					let elems = []
					while (elem.nextElementSibling && elem.nextElementSibling.tagName !== 'h3') {
						elems.push(elem.nextElementSibling)
						elem = elem.nextElementSibling
					}

					// Delete the old versions of the content nodes
					elems.forEach((node) => {
						node.parentNode.removeChild(node)
					})

					return elems
				}

				// Assign the contents to be expanded/collapsed (array)
				let contents = getContent(heading)

				// Create a wrapper element for `contents` and hide it
				let wrapper = document.createElement('div')
				wrapper.hidden = true

				// Add each element of `contents` to `wrapper`
				contents.forEach(node => {
					wrapper.appendChild(node)
				})

				// Add the wrapped content back into the DOM
				// after the heading
				heading.parentNode.insertBefore(wrapper, heading.nextElementSibling)

				// Assign the button
				let btn = heading.querySelector('button')

				let parent = heading.parentNode;

				btn.onclick = () => {
					// Cast the state as a boolean
					let expanded = btn.getAttribute('aria-expanded') === 'true' || false;
					// toggle expanded status on parent
					parent.classList.toggle('is-expanded');
					// Switch the state
					btn.setAttribute('aria-expanded', !expanded)
					// Switch the content's visibility
					wrapper.hidden = expanded
				}

			})

		}

	};


	setupAccordion();


	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=accordion', initializeBlock);
	}

})();